import Gallery from '../Page/Gallery';

export default Gallery;
